import * as React from 'react';
import styled from 'styled-components';
import Container, { ContainerProps as MuiContainerProps } from '@material-ui/core/Container';

const StyledContainer = styled(Container)``;

export type DSContainerProps = MuiContainerProps;
export const DSContainer: React.FC<DSContainerProps> = StyledContainer;
DSContainer.displayName = 'DSContainer';
